const fr = {
  "common.skip_content": "Aller au contenu",
  "voyage.hero.eyebrow": "Marketplace · Voyage",
  "voyage.hero.title": "Voyager ensemble",
  "voyage.hero.subtitle": "Voyagez autrement, ensemble.",
  "voyage.hero.my_trips": "Mes voyages",
  "voyage.planner.title": "Planifier un voyage",
  "voyage.planner.origin": "Départ",
  "voyage.planner.destination": "Destination",
  "voyage.planner.dates": "Dates",
  "voyage.planner.start": "Date de départ",
  "voyage.planner.end": "Date de retour",
  "voyage.planner.date_placeholder": "JJ/MM/AAAA",
  "voyage.planner.travellers": "Voyageurs",
  "voyage.planner.budget": "Budget",
  "voyage.planner.errors_title": "Plusieurs informations sont à corriger",
  "voyage.planner.error.origin.required": "Indiquez une ville de départ.",
  "voyage.planner.error.destination.required": "Indiquez une destination.",
  "voyage.planner.error.destination.same_place": "Le départ et la destination doivent être différents.",
  "voyage.planner.error.start.invalid": "Saisissez une date de départ au format JJ/MM/AAAA.",
  "voyage.planner.error.start.past": "La date de départ ne peut pas être passée.",
  "voyage.planner.error.end.invalid": "Saisissez une date de retour au format JJ/MM/AAAA.",
  "voyage.planner.error.end.before_start": "La date de retour ne peut pas précéder le départ.",
  "voyage.planner.error.travellers.invalid": "Choisissez entre 1 et 8 voyageurs.",
  "voyage.planner.error.budget.invalid": "Choisissez un niveau de budget proposé.",
  "voyage.traveller.one": "voyageur",
  "voyage.traveller.many": "voyageurs",
  "voyage.budget.economique": "Économique",
  "voyage.budget.confort": "Confort",
  "voyage.budget.premium": "Premium",
  "voyage.search.submit": "Explorer",
  "voyage.search.loading": "Recherche en cours…",
  "voyage.search.complete": "Recherche terminée. Les résultats locaux sont identifiés comme démonstration.",
  "voyage.search.fix_errors": "Corrigez les champs signalés avant de continuer.",
  "voyage.search.empty_title": "Aucun aperçu local ne correspond",
  "voyage.search.empty_text": "Aucun résultat de démonstration pour cette destination. Modifiez vos critères.",
  "voyage.search.reset": "Réinitialiser",
  "voyage.destinations.kicker": "Source locale identifiée",
  "voyage.destinations.title": "Destinations d’exception",
  "voyage.destinations.no_source_title": "Aucune source de destinations disponible",
  "voyage.destinations.no_source_text": "Une source autoritative doit être connectée avant d’afficher des offres réelles.",
  "voyage.demo.badge": "Aperçu local",
  "voyage.demo.explainer": "Contenus de démonstration · aucun prix ni disponibilité",
  "voyage.demo.no_price": "Aucun tarif affiché",
  "voyage.demo.cote_azur_alt": "La côte méditerranéenne près de Nice",
  "voyage.demo.kyoto_alt": "Un temple japonais devant les montagnes de Kyoto",
  "voyage.demo.bali_alt": "Un temple balinais au bord de l’eau",
  "voyage.favorite.add": "Ajouter aux favoris",
  "voyage.favorite.remove": "Retirer des favoris",
  "voyage.destination.selected": "Destination sélectionnée dans l’aperçu",
  "voyage.cotravellers.kicker": "Confidentialité et confiance",
  "voyage.cotravellers.title": "Co-voyageurs",
  "voyage.cotravellers.empty_title": "Aucun profil déclaré à afficher",
  "voyage.cotravellers.empty_text": "Les profils ne seront proposés qu’après connexion à une source autoritative et selon vos permissions.",
  "voyage.itinerary.title": "Mon itinéraire",
  "voyage.itinerary.empty_title": "Itinéraire vide",
  "voyage.itinerary.empty_text": "Ajoutez un départ et une destination pour commencer.",
  "voyage.itinerary.estimate": "Estimation indicative",
  "voyage.itinerary.no_estimate": "Aucune estimation tarifaire disponible",
  "voyage.itinerary.no_estimate_help": "Aucun prix réel n’est fourni par une source Voyage autoritative.",
  "voyage.itinerary.create": "Créer mon voyage",
  "voyage.itinerary.save": "Enregistrer",
  "voyage.itinerary.saved": "Enregistré sur cet appareil",
  "voyage.save.local_success": "Itinéraire enregistré sur cet appareil. Il n’est pas synchronisé.",
  "voyage.save.local_error": "L’itinéraire n’a pas pu être enregistré sur cet appareil.",
  "voyage.agenda.add": "Ajouter à mon agenda",
  "voyage.agenda.adding": "Ajout en cours…",
  "voyage.agenda.added": "Ajouté à mon agenda",
  "voyage.agenda.private": "L’événement sera privé par défaut dans l’agenda central.",
  "voyage.agenda.offline": "Agenda indisponible hors connexion.",
  "voyage.agenda.success": "L’itinéraire a été ajouté à votre agenda privé.",
  "voyage.agenda.error": "L’agenda est momentanément indisponible. Vos critères sont conservés.",
  "voyage.agenda.unavailable_title": "Agenda indisponible",
  "voyage.agenda.unavailable_text": "Réessayez plus tard. Aucune entrée partielle n’a été annoncée.",
  "voyage.agenda.event_prefix": "Voyage",
  "voyage.agenda.event_description": "Itinéraire privé Eternua",
  "voyage.offline.title": "Vous êtes hors connexion",
  "voyage.offline.text": "Les aperçus locaux restent visibles, mais aucune action serveur n’est disponible.",
  "voyage.session.title": "Session expirée",
  "voyage.session.expired": "Votre session a expiré. Reconnectez-vous pour reprendre.",
  "voyage.session.text": "Reconnectez-vous : l’URL conserve votre itinéraire sans donnée sensible.",
  "voyage.common.retry": "Réessayer",
  "voyage.preparation.badge": "En préparation",
  "voyage.preparation.generic": "Cette rubrique est en préparation.",
  "voyage.preparation.itinerary": "La gestion serveur des itinéraires est en préparation. Votre recherche reste conservée dans l’URL.",
  "voyage.preparation.lodging": "Aucune source d’hébergements autoritative n’est encore reliée à Eternua Voyage.",
  "voyage.preparation.tips": "Les conseils éditoriaux seront publiés lorsqu’une source et une politique de mise à jour auront été validées.",
  "voyage.preparation.back": "Retour à l’accueil Voyage",
  "voyage.drawer.kicker": "Navigation",
  "voyage.drawer.title": "Explorer Voyage",
  "voyage.drawer.open": "Ouvrir Explorer Voyage",
  "voyage.drawer.close": "Fermer Explorer Voyage",
  "voyage.drawer.close_short": "Fermer Voyage",
  "voyage.drawer.opened": "Menu Voyage ouvert",
  "voyage.drawer.closed": "Menu Voyage fermé",
  "voyage.drawer.note": "Retrouvez les destinations, les étapes et les compagnons de votre prochain voyage.",
  "voyage.carpool.title": "Covoiturage Eternua",
  "voyage.carpool.intro": "Des trajets humains et transparents à partir des données du module Covoiturage.",
  "voyage.carpool.nav": "Navigation Covoiturage",
  "voyage.carpool.discover": "Découvrir",
  "voyage.carpool.discover_desc": "Accueil du covoiturage",
  "voyage.carpool.search": "Rechercher",
  "voyage.carpool.search_desc": "Trouver un trajet disponible",
  "voyage.carpool.publish": "Publier un trajet",
  "voyage.carpool.publish_desc": "Proposer des places",
  "voyage.carpool.my_rides": "Mes trajets",
  "voyage.carpool.my_rides_desc": "Gérer vos publications",
  "voyage.carpool.bookings": "Mes réservations",
  "voyage.carpool.bookings_desc": "Suivre vos demandes",
  "voyage.carpool.payments": "Mes paiements",
  "voyage.carpool.payments_desc": "Du paiement au versement",
};

const en = {
  ...fr,
  "common.skip_content": "Skip to content",
  "voyage.hero.eyebrow": "Marketplace · Travel",
  "voyage.hero.title": "Travel together",
  "voyage.hero.subtitle": "Travel differently, together.",
  "voyage.hero.my_trips": "My trips",
  "voyage.planner.title": "Plan a trip",
  "voyage.planner.origin": "From",
  "voyage.planner.destination": "Destination",
  "voyage.planner.dates": "Dates",
  "voyage.planner.start": "Departure date",
  "voyage.planner.end": "Return date",
  "voyage.planner.date_placeholder": "DD/MM/YYYY",
  "voyage.planner.travellers": "Travellers",
  "voyage.planner.budget": "Budget",
  "voyage.planner.errors_title": "Several details need your attention",
  "voyage.planner.error.origin.required": "Enter a departure city.",
  "voyage.planner.error.destination.required": "Enter a destination.",
  "voyage.planner.error.destination.same_place": "Departure and destination must be different.",
  "voyage.planner.error.start.invalid": "Enter the departure date as DD/MM/YYYY.",
  "voyage.planner.error.start.past": "The departure date cannot be in the past.",
  "voyage.planner.error.end.invalid": "Enter the return date as DD/MM/YYYY.",
  "voyage.planner.error.end.before_start": "The return date cannot be before departure.",
  "voyage.planner.error.travellers.invalid": "Choose between 1 and 8 travellers.",
  "voyage.planner.error.budget.invalid": "Choose one of the available budget levels.",
  "voyage.traveller.one": "traveller",
  "voyage.traveller.many": "travellers",
  "voyage.budget.economique": "Economy",
  "voyage.budget.confort": "Comfort",
  "voyage.search.submit": "Explore",
  "voyage.search.loading": "Searching…",
  "voyage.search.complete": "Search complete. Local results are identified as demo content.",
  "voyage.search.fix_errors": "Correct the highlighted fields before continuing.",
  "voyage.search.empty_title": "No local preview matches",
  "voyage.search.empty_text": "No demo result for this destination. Change your criteria.",
  "voyage.search.reset": "Reset",
  "voyage.destinations.kicker": "Identified local source",
  "voyage.destinations.title": "Exceptional destinations",
  "voyage.destinations.no_source_title": "No destination source available",
  "voyage.destinations.no_source_text": "An authoritative source must be connected before real offers can be shown.",
  "voyage.demo.badge": "Local preview",
  "voyage.demo.explainer": "Demo content · no prices or availability",
  "voyage.demo.no_price": "No price shown",
  "voyage.demo.cote_azur_alt": "The Mediterranean coast near Nice",
  "voyage.demo.kyoto_alt": "A Japanese temple in front of Kyoto’s mountains",
  "voyage.demo.bali_alt": "A Balinese temple by the water",
  "voyage.favorite.add": "Add to favourites",
  "voyage.favorite.remove": "Remove from favourites",
  "voyage.destination.selected": "Destination selected in the preview",
  "voyage.cotravellers.kicker": "Privacy and trust",
  "voyage.cotravellers.title": "Travel companions",
  "voyage.cotravellers.empty_title": "No verified profile to display",
  "voyage.cotravellers.empty_text": "Profiles will only be suggested after an authoritative source is connected and according to your permissions.",
  "voyage.itinerary.title": "My itinerary",
  "voyage.itinerary.empty_title": "Empty itinerary",
  "voyage.itinerary.empty_text": "Add a departure point and destination to begin.",
  "voyage.itinerary.estimate": "Indicative estimate",
  "voyage.itinerary.no_estimate": "No price estimate available",
  "voyage.itinerary.no_estimate_help": "No real price is supplied by an authoritative Travel source.",
  "voyage.itinerary.create": "Create my trip",
  "voyage.itinerary.save": "Save",
  "voyage.itinerary.saved": "Saved on this device",
  "voyage.save.local_success": "Itinerary saved on this device. It is not synced.",
  "voyage.save.local_error": "The itinerary could not be saved on this device.",
  "voyage.agenda.add": "Add to my calendar",
  "voyage.agenda.adding": "Adding…",
  "voyage.agenda.added": "Added to my calendar",
  "voyage.agenda.private": "The event will be private by default in the central calendar.",
  "voyage.agenda.offline": "Calendar unavailable offline.",
  "voyage.agenda.success": "The itinerary was added to your private calendar.",
  "voyage.agenda.error": "The calendar is temporarily unavailable. Your criteria are preserved.",
  "voyage.agenda.unavailable_title": "Calendar unavailable",
  "voyage.agenda.unavailable_text": "Try again later. No partial entry has been reported as saved.",
  "voyage.agenda.event_prefix": "Trip",
  "voyage.agenda.event_description": "Private Eternua itinerary",
  "voyage.offline.title": "You are offline",
  "voyage.offline.text": "Local previews remain visible, but server actions are unavailable.",
  "voyage.session.title": "Session expired",
  "voyage.session.expired": "Your session has expired. Sign in again to continue.",
  "voyage.session.text": "Sign in again: the URL preserves your itinerary without sensitive data.",
  "voyage.common.retry": "Try again",
  "voyage.preparation.badge": "In preparation",
  "voyage.preparation.generic": "This section is being prepared.",
  "voyage.preparation.itinerary": "Server-side itinerary management is being prepared. Your search remains in the URL.",
  "voyage.preparation.lodging": "No authoritative accommodation source is connected to Eternua Travel yet.",
  "voyage.preparation.tips": "Editorial advice will be published once its source and update policy have been approved.",
  "voyage.preparation.back": "Back to Travel home",
  "voyage.drawer.kicker": "Navigation",
  "voyage.drawer.title": "Explore Travel",
  "voyage.drawer.open": "Open Explore Travel",
  "voyage.drawer.close": "Close Explore Travel",
  "voyage.drawer.close_short": "Close Travel",
  "voyage.drawer.opened": "Travel menu opened",
  "voyage.drawer.closed": "Travel menu closed",
  "voyage.drawer.note": "Find destinations, itinerary stops and companions for your next trip.",
  "voyage.carpool.title": "Eternua Carpooling",
  "voyage.carpool.intro": "Human, transparent journeys using data from the Carpooling module.",
  "voyage.carpool.nav": "Carpooling navigation",
  "voyage.carpool.discover": "Discover",
  "voyage.carpool.discover_desc": "Carpooling home",
  "voyage.carpool.search": "Search",
  "voyage.carpool.search_desc": "Find an available trip",
  "voyage.carpool.publish": "Publish a trip",
  "voyage.carpool.publish_desc": "Offer seats",
  "voyage.carpool.my_rides": "My trips",
  "voyage.carpool.my_rides_desc": "Manage your posts",
  "voyage.carpool.bookings": "My bookings",
  "voyage.carpool.bookings_desc": "Track your requests",
  "voyage.carpool.payments": "My payments",
  "voyage.carpool.payments_desc": "From payment to payout",
};

const es = {
  ...en,
  "common.skip_content": "Ir al contenido",
  "voyage.hero.eyebrow": "Marketplace · Viaje",
  "voyage.hero.title": "Viajar juntos",
  "voyage.hero.subtitle": "Viaja de otra manera, juntos.",
  "voyage.hero.my_trips": "Mis viajes",
  "voyage.planner.title": "Planificar un viaje",
  "voyage.planner.origin": "Salida",
  "voyage.planner.destination": "Destino",
  "voyage.planner.dates": "Fechas",
  "voyage.planner.start": "Fecha de salida",
  "voyage.planner.end": "Fecha de regreso",
  "voyage.planner.travellers": "Viajeros",
  "voyage.planner.errors_title": "Hay varios datos que corregir",
  "voyage.planner.error.origin.required": "Indica una ciudad de salida.",
  "voyage.planner.error.destination.required": "Indica un destino.",
  "voyage.planner.error.destination.same_place": "La salida y el destino deben ser diferentes.",
  "voyage.planner.error.start.invalid": "Escribe la fecha de salida como DD/MM/AAAA.",
  "voyage.planner.error.start.past": "La fecha de salida no puede estar en el pasado.",
  "voyage.planner.error.end.invalid": "Escribe la fecha de regreso como DD/MM/AAAA.",
  "voyage.planner.error.end.before_start": "El regreso no puede ser anterior a la salida.",
  "voyage.planner.error.travellers.invalid": "Elige entre 1 y 8 viajeros.",
  "voyage.planner.error.budget.invalid": "Elige un nivel de presupuesto disponible.",
  "voyage.traveller.one": "viajero",
  "voyage.traveller.many": "viajeros",
  "voyage.budget.economique": "Económico",
  "voyage.budget.confort": "Confort",
  "voyage.search.submit": "Explorar",
  "voyage.search.loading": "Buscando…",
  "voyage.search.fix_errors": "Corrige los campos señalados antes de continuar.",
  "voyage.search.empty_title": "No hay una vista previa local",
  "voyage.search.empty_text": "No hay resultado de demostración para este destino. Cambia los criterios.",
  "voyage.search.reset": "Restablecer",
  "voyage.destinations.kicker": "Fuente local identificada",
  "voyage.destinations.title": "Destinos excepcionales",
  "voyage.demo.badge": "Vista local",
  "voyage.demo.explainer": "Contenido de demostración · sin precios ni disponibilidad",
  "voyage.demo.no_price": "Sin tarifa mostrada",
  "voyage.favorite.add": "Añadir a favoritos",
  "voyage.favorite.remove": "Quitar de favoritos",
  "voyage.cotravellers.title": "Compañeros de viaje",
  "voyage.cotravellers.empty_title": "No hay perfiles verificados para mostrar",
  "voyage.itinerary.title": "Mi itinerario",
  "voyage.itinerary.empty_title": "Itinerario vacío",
  "voyage.itinerary.estimate": "Estimación orientativa",
  "voyage.itinerary.no_estimate": "No hay estimación de precio disponible",
  "voyage.itinerary.create": "Crear mi viaje",
  "voyage.itinerary.save": "Guardar",
  "voyage.itinerary.saved": "Guardado en este dispositivo",
  "voyage.agenda.add": "Añadir a mi agenda",
  "voyage.agenda.adding": "Añadiendo…",
  "voyage.agenda.added": "Añadido a mi agenda",
  "voyage.agenda.unavailable_title": "Agenda no disponible",
  "voyage.offline.title": "Estás sin conexión",
  "voyage.session.title": "Sesión caducada",
  "voyage.common.retry": "Reintentar",
  "voyage.preparation.badge": "En preparación",
  "voyage.preparation.back": "Volver al inicio de Viaje",
  "voyage.drawer.title": "Explorar Viaje",
  "voyage.drawer.open": "Abrir Explorar Viaje",
  "voyage.drawer.close": "Cerrar Explorar Viaje",
};

const it = {
  ...en,
  "common.skip_content": "Vai al contenuto",
  "voyage.hero.eyebrow": "Marketplace · Viaggio",
  "voyage.hero.title": "Viaggiare insieme",
  "voyage.hero.subtitle": "Viaggia in modo diverso, insieme.",
  "voyage.hero.my_trips": "I miei viaggi",
  "voyage.planner.title": "Pianificare un viaggio",
  "voyage.planner.origin": "Partenza",
  "voyage.planner.destination": "Destinazione",
  "voyage.planner.dates": "Date",
  "voyage.planner.start": "Data di partenza",
  "voyage.planner.end": "Data di ritorno",
  "voyage.planner.travellers": "Viaggiatori",
  "voyage.planner.errors_title": "Ci sono informazioni da correggere",
  "voyage.planner.error.origin.required": "Indica una città di partenza.",
  "voyage.planner.error.destination.required": "Indica una destinazione.",
  "voyage.planner.error.destination.same_place": "Partenza e destinazione devono essere diverse.",
  "voyage.planner.error.start.invalid": "Inserisci la partenza come GG/MM/AAAA.",
  "voyage.planner.error.start.past": "La data di partenza non può essere passata.",
  "voyage.planner.error.end.invalid": "Inserisci il ritorno come GG/MM/AAAA.",
  "voyage.planner.error.end.before_start": "Il ritorno non può precedere la partenza.",
  "voyage.planner.error.travellers.invalid": "Scegli da 1 a 8 viaggiatori.",
  "voyage.planner.error.budget.invalid": "Scegli un livello di budget disponibile.",
  "voyage.traveller.one": "viaggiatore",
  "voyage.traveller.many": "viaggiatori",
  "voyage.budget.economique": "Economico",
  "voyage.search.submit": "Esplora",
  "voyage.search.loading": "Ricerca in corso…",
  "voyage.search.fix_errors": "Correggi i campi segnalati prima di continuare.",
  "voyage.search.empty_title": "Nessuna anteprima locale corrisponde",
  "voyage.search.reset": "Reimposta",
  "voyage.destinations.kicker": "Fonte locale identificata",
  "voyage.destinations.title": "Destinazioni eccezionali",
  "voyage.demo.badge": "Anteprima locale",
  "voyage.demo.explainer": "Contenuto dimostrativo · nessun prezzo o disponibilità",
  "voyage.demo.no_price": "Nessun prezzo mostrato",
  "voyage.favorite.add": "Aggiungi ai preferiti",
  "voyage.favorite.remove": "Rimuovi dai preferiti",
  "voyage.cotravellers.title": "Compagni di viaggio",
  "voyage.itinerary.title": "Il mio itinerario",
  "voyage.itinerary.empty_title": "Itinerario vuoto",
  "voyage.itinerary.estimate": "Stima indicativa",
  "voyage.itinerary.no_estimate": "Nessuna stima di prezzo disponibile",
  "voyage.itinerary.create": "Crea il mio viaggio",
  "voyage.itinerary.save": "Salva",
  "voyage.itinerary.saved": "Salvato su questo dispositivo",
  "voyage.agenda.add": "Aggiungi alla mia agenda",
  "voyage.agenda.adding": "Aggiunta in corso…",
  "voyage.agenda.added": "Aggiunto alla mia agenda",
  "voyage.agenda.unavailable_title": "Agenda non disponibile",
  "voyage.offline.title": "Sei offline",
  "voyage.session.title": "Sessione scaduta",
  "voyage.common.retry": "Riprova",
  "voyage.preparation.badge": "In preparazione",
  "voyage.preparation.back": "Torna alla home Viaggio",
  "voyage.drawer.title": "Esplora Viaggio",
  "voyage.drawer.open": "Apri Esplora Viaggio",
  "voyage.drawer.close": "Chiudi Esplora Viaggio",
};

const de = {
  ...en,
  "common.skip_content": "Zum Inhalt springen",
  "voyage.hero.eyebrow": "Marketplace · Reisen",
  "voyage.hero.title": "Gemeinsam reisen",
  "voyage.hero.subtitle": "Anders reisen, gemeinsam.",
  "voyage.hero.my_trips": "Meine Reisen",
  "voyage.planner.title": "Reise planen",
  "voyage.planner.origin": "Abfahrt",
  "voyage.planner.destination": "Ziel",
  "voyage.planner.dates": "Reisedaten",
  "voyage.planner.start": "Abfahrtsdatum",
  "voyage.planner.end": "Rückreisedatum",
  "voyage.planner.travellers": "Reisende",
  "voyage.planner.errors_title": "Mehrere Angaben müssen korrigiert werden",
  "voyage.planner.error.origin.required": "Gib einen Abfahrtsort ein.",
  "voyage.planner.error.destination.required": "Gib ein Reiseziel ein.",
  "voyage.planner.error.destination.same_place": "Abfahrt und Ziel müssen verschieden sein.",
  "voyage.planner.error.start.invalid": "Gib die Abfahrt als TT/MM/JJJJ ein.",
  "voyage.planner.error.start.past": "Das Abfahrtsdatum darf nicht vergangen sein.",
  "voyage.planner.error.end.invalid": "Gib die Rückreise als TT/MM/JJJJ ein.",
  "voyage.planner.error.end.before_start": "Die Rückreise darf nicht vor der Abfahrt liegen.",
  "voyage.planner.error.travellers.invalid": "Wähle 1 bis 8 Reisende.",
  "voyage.planner.error.budget.invalid": "Wähle eine verfügbare Budgetstufe.",
  "voyage.traveller.one": "Reisender",
  "voyage.traveller.many": "Reisende",
  "voyage.budget.economique": "Günstig",
  "voyage.search.submit": "Entdecken",
  "voyage.search.loading": "Suche läuft…",
  "voyage.search.fix_errors": "Korrigiere die markierten Felder, bevor du fortfährst.",
  "voyage.search.empty_title": "Keine lokale Vorschau passt",
  "voyage.search.reset": "Zurücksetzen",
  "voyage.destinations.kicker": "Identifizierte lokale Quelle",
  "voyage.destinations.title": "Außergewöhnliche Reiseziele",
  "voyage.demo.badge": "Lokale Vorschau",
  "voyage.demo.explainer": "Demoinhalt · keine Preise oder Verfügbarkeit",
  "voyage.demo.no_price": "Kein Preis angezeigt",
  "voyage.favorite.add": "Zu Favoriten hinzufügen",
  "voyage.favorite.remove": "Aus Favoriten entfernen",
  "voyage.cotravellers.title": "Mitreisende",
  "voyage.itinerary.title": "Meine Reiseroute",
  "voyage.itinerary.empty_title": "Leere Reiseroute",
  "voyage.itinerary.estimate": "Unverbindliche Schätzung",
  "voyage.itinerary.no_estimate": "Keine Preisschätzung verfügbar",
  "voyage.itinerary.create": "Meine Reise erstellen",
  "voyage.itinerary.save": "Speichern",
  "voyage.itinerary.saved": "Auf diesem Gerät gespeichert",
  "voyage.agenda.add": "Zu meinem Kalender hinzufügen",
  "voyage.agenda.adding": "Wird hinzugefügt…",
  "voyage.agenda.added": "Zum Kalender hinzugefügt",
  "voyage.agenda.unavailable_title": "Kalender nicht verfügbar",
  "voyage.offline.title": "Du bist offline",
  "voyage.session.title": "Sitzung abgelaufen",
  "voyage.common.retry": "Erneut versuchen",
  "voyage.preparation.badge": "In Vorbereitung",
  "voyage.preparation.back": "Zurück zur Reisen-Startseite",
  "voyage.drawer.title": "Reisen entdecken",
  "voyage.drawer.open": "Reisen entdecken öffnen",
  "voyage.drawer.close": "Reisen entdecken schließen",
};

export const VOYAGE_DELUXE_TRANSLATIONS = { fr, en, es, it, de, et: fr };
